import { render, staticRenderFns } from "./modalAnadirProducto.vue?vue&type=template&id=1270c628&scoped=true&"
import script from "./modalAnadirProducto.vue?vue&type=script&lang=js&"
export * from "./modalAnadirProducto.vue?vue&type=script&lang=js&"
import style0 from "./modalAnadirProducto.vue?vue&type=style&index=0&id=1270c628&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1270c628",
  null
  
)

export default component.exports